import { Form, Input } from "decorator-form";
import EntitySelect from "../../../common/form/fields/entitySelect/EntitySelect";
import Forum from "../entity/Forum";



const forumSelect = EntitySelect.registered({entity: Forum, type: 'one'}, 'string');

@Form({title: "Forum Subscription Config"})
export default class ForumSubscriptionConfig {

	@Input({type: forumSelect, title: "Forum"})
	public forumId: string;
}



// WEBPACK FOOTER //
// ./src/panels/forum/config/ForumSubscriptionConfig.ts